<div class="app-study-history">
  <div class="study-history-table">
    <div class="history-row">
      <mat-card
        *ngFor="let headerCell of studyHistoryTable?.headerRow"
        class="history-cell history-header-cell"
      >
        <div class="history-title">{{ headerCell.title }}</div>
        <div class="history-text">{{ headerCell.content }}</div>
      </mat-card>
    </div>
    <div
      class="history-row"
      *ngFor="let historyTableRow of studyHistoryTable?.bodyRows"
    >
      <mat-card
        *ngFor="let historyTableCell of historyTableRow"
        class="history-cell"
        [ngClass]="{
          'history-cell--has-changed': historyTableCell.hasChanged
        }"
      >
        <div class="history-title">{{ historyTableCell.title }}</div>
        <div class="history-subtitle">{{ historyTableCell.subtitle }}</div>
        <div
          class="history-content"
          [ngClass]="{
            'history-content--is-array': isArray(historyTableCell.content)
          }"
        >
          @if (isArray(historyTableCell.content)) {
            <ul>
              @for (item of historyTableCell.content; track $index) {
                <li>{{ item }}</li>
              }
            </ul>
          } @else {
            {{ historyTableCell.content }}
          }
        </div>
      </mat-card>
    </div>
  </div>
</div>
